<script setup lang="ts">
  import { marked } from 'marked'
  import { cva } from 'class-variance-authority'

  const props = withDefaults(
    defineProps<{
      blok: any
      even?: boolean
    }>(),
    {
      even: false
    }
  )

  const orderVariant = cva('', {
    variants: {
      base: {
        even: 'justify-end',
        odd: 'justify-start'
      },
      image: {
        even: 'md:order-1',
        odd: 'md:order-0'
      }
    }
  })

  const output = computed(() => marked(props.blok.content))

  const hasImage = computed(() => !!props.blok?.image?.filename)
  const orderType = computed(() => (props.even ? 'even' : 'odd'))

  const { isDesktopSmall, isDesktopLarge } = useBTBreakpoints()

  const imageWidth = computed(() => {
    if (isDesktopLarge.value) {
      return 978
    }

    if (isDesktopSmall.value) {
      return 682
    }

    return 728
  })

  const imageHeight = computed(() => {
    if (isDesktopLarge.value) {
      return 552
    }

    if (isDesktopSmall.value) {
      return 384
    }

    return 200
  })
</script>

<template>
  <div
    v-editable="blok"
    class="flex flex-col overflow-hidden rounded-b-sm shadow-xs md:flex-row md:gap-20 md:rounded-none md:shadow-none"
    :class="orderVariant({ base: orderType })"
  >
    <!--  16 / 9 -->
    <div
      v-if="hasImage"
      class="h-50 md:h-96 md:max-w-244 xl:h-138"
      :class="orderVariant({ image: orderType })"
    >
      <NuxtImg
        provider="storyblok"
        :src="blok.image.filename"
        :alt="blok.image.alt"
        class="size-full rounded-t-sm object-cover md:rounded-md"
        loading="lazy"
        :height="imageHeight"
        :width="imageWidth"
        :modifiers="{ filters: { focal: blok?.image?.focus }, smart: true }"
      />
    </div>

    <div class="px-4 pb-10 pt-6 md:max-w-90 md:shrink-0 md:p-0">
      <div
        class="[&_a]:text-inherit"
        v-html="output"
      />
    </div>
  </div>
</template>
